import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import type { PlumaTheme, PartialPlumaTheme } from '@/css/themes/pluma-theme';
import { provide } from 'ember-provide-consume-context';
export const PlumaThemeContext = 'pluma-theme-context' as const;
interface ThemeContextProviderSignature {
    Args: {
        theme?: PlumaTheme | PartialPlumaTheme | null;
    };
    Blocks: {
        default: [];
    };
}
export default class ThemeContextProvider extends Component<ThemeContextProviderSignature> {
    @provide(PlumaThemeContext)
    get value() {
        return this.args.theme;
    }
    static{
        template(`{{yield}}`, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
declare module 'ember-provide-consume-context/context-registry' {
    export default interface ContextRegistry {
        [PlumaThemeContext]: PlumaTheme | PartialPlumaTheme | null;
    }
}
